import { Iterable, List } from 'immutable';
import type { ImmutableRecord } from './immutable-types';

export function isImmutableRecord<T = string>(value: unknown): value is ImmutableRecord<T> {
  return Iterable.isIterable(value);
}

export function isImmutableList<T = string>(value: unknown): value is List<T> {
  return List.isList(value);
}
